<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div :class="panelMode ? 'p-3' :'container mt-4 mb-4'">
    <div class="mt-2" style="max-width:597px">
        <h3>Legg til kategori</h3>
        <br/>
        <div>
          <span class="ingredient-title">Navn</span>
          <input id="name" class="form-control" type="text" v-model="category.name"/>
        </div>

        <div class="mb-4">
          <span class="ingredient-title">Hva skal kategorien inneholde?</span>
          <select class="form-select" v-model="category.itemType">
            <option value="">Velg type</option>
            <option value="DISH">Matrett</option>
            <option value="DRINK_BUBBLE_TEA">Bubble tea</option>
            <option value="DRINK">Drikke UTEN alkohol</option>
            <option value="DRINK_ALCOHOL">Drikke MED alkohol</option>
            <option value="ADD_ON">Tilbehør</option> <!-- itemType ADD_ON for item in category -->
            <option v-if="offerDeliveryService" value="DELIVERY_SERVICE">Leveringstjeneste</option>
          </select>
        </div>

        <div v-if="hasMultiLocations()">
          <span class="ingredient-title">Tilgjengelig på følgende avdelinger</span>
          <fieldset>
            <label v-for="(location, index) in locations" :key="index" class="multiple-checkbox-label">
              <input type="checkbox" :name="location.name" :value="location.id" @click="setSelectedLocations" class="multiple-checkbox"
                     :checked="category.availableAtLocationIds.indexOf(location.id) > -1" /> {{ location.name }}
            </label>
          </fieldset>
        </div>

        <div v-if="showAvailableForChannels()">
          <span class="ingredient-title">Tilgjengelig på følgende kanaler</span>
          <fieldset>
            <label v-for="(channel, index) in channels" :key="index" class="multiple-checkbox-label">
              <input type="checkbox" :name="channel.name" :value="channel.id" @click="setSelectedChannels" class="multiple-checkbox"
                     :checked="category.availableForChannelIds.indexOf(channel.id) > -1" /> {{ channel.name }}
            </label>
          </fieldset>
        </div>

        <div v-if="showAvailableForOrderTypes()">
          <span class="ingredient-title">Tilgjengelig for</span>
          <fieldset>
            <label v-for="(orderType, index) in orderTypes" :key="index" class="multiple-checkbox-label">
              <input type="checkbox" :name="orderType" :value="orderType" @click="setSelectedOrderTypes" class="multiple-checkbox"
                     :checked="category.availableForOrderTypes.indexOf(orderType) > -1" /> {{ getOrderTypeName(orderType) }}
            </label>
          </fieldset>
        </div>

        <div v-if="showAvailableOnDays()">
          <span class="ingredient-title">Tilgjengelig på følgende dager</span>
          <fieldset>
            <label v-for="(day, index) in days" :key="index" class="multiple-checkbox-label">
              <input type="checkbox" :name="day" :value="day" @click="setSelectedDays" class="multiple-checkbox"
                     :checked="category.availableOnDays.indexOf(day) > -1" /> {{ getDayName(day) }}
            </label>
          </fieldset>
        </div>

        <div class="mt-4">
          <div class="bo_label">Bilde</div>
          <div style="margin-top: -10px">Dette kategoribildet vises bare i selvbetjeningskiosk og kasse.</div>
          <div class="mt-4 mb-4">
              <input type="file" class="form-control" accept="image/png,image/jpeg,image/avif,image/webp" ref="file" @change="selectFile" />
          </div>
        </div>

        <div>
          <span class="bo_label">Beskrivelse</span>
          <textarea id="description" class="form-control" type="text" v-model="category.description" rows="3" cols="50"></textarea>
        </div>

        <div v-if="!panelMode" class="bo_hr mt-4">
          <hr/>
        </div>

        <div v-if="!panelMode" class="mb-5">
          <button v-if="activateSaveButton" type="button" class="bo_btn" @click="saveCategory"> Lagre </button>
          <button v-else type="button" class="bo_btn" @click="saveCategory" disabled="true"> Lagre </button>
        </div>
    </div>
    <div v-if="panelMode" class="panel-sticky-footer">
      <button v-if="activateSaveButton" type="button" class="bo_btn" @click="saveCategory"> Lagre </button>
      <button v-else type="button" class="bo_btn" @click="saveCategory" disabled="true"> Lagre </button>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import ChannelUtil from "@/util/ChannelUtil";
import MerchantUtil from "@/util/MerchantUtil";
import ProductService from "@/services/product/ProductService";
import MediaFileService from "@/services/media/MediaFileService";
import ImageCompressor from "@/util/ImageCompressor";
import LocationService from "@/services/location/LocationService";
import LocationUtil from "@/util/LocationUtil";

export default {
  components: {LoadingSpinner},
  props: {
    panelMode: { type: Boolean, default: false }
  },
  emits: ['saved'],
  data() {
    return {
      loading: false,

      channels: ChannelUtil.CHANNELS, //one list with the channel line and filter on /products
      locations: [],
      days: ["MONDAY", "TUESDAY","WEDNESDAY","THURSDAY","FRIDAY","SATURDAY","SUNDAY"],
      imageFile: undefined,
      //True while the ticks on screen were imposed by the chosen type rather than picked by a
      //person, so switching to an unrestricted type restores the default instead of inheriting a
      //restriction. Deliberately NOT inside `category` — it describes the form, not the document.
      orderTypesForcedByType: false,
      category: {
        type: "category",
        merchant: "",
        sortOrder: -1,
        name: "",
        availableAtLocationIds: [],
        availableForChannelIds: ['POS', 'KIOSK', 'WEB_DINE_IN', 'WEB_TAKEAWAY'], //default checked
        availableForOrderTypes: ['DINE_IN', 'TAKEAWAY'], //default checked
        availableOnDays: ["MONDAY", "TUESDAY","WEDNESDAY","THURSDAY","FRIDAY","SATURDAY","SUNDAY"], //default checked
        imageUrl: "",
        description: "",
        showItemsCount: true,
        itemType: ""
      }
    };
  },
  mounted() {
    if(MerchantUtil.showAvailableOnDaysHolidayOption()){
      this.days.push("HOLIDAY");
    }

    LocationService.listLocations().then(
        (response) => {
          this.locations = response.data;
          //console.log('locations: ' + JSON.stringify(this.locations));

          //All locations selected by default
          for (let i = 0; i < this.locations.length; i++) {
              let location = this.locations[i];
              this.category.availableAtLocationIds.push(location.id);
          }

          this.loading = false;
        },
        (error) => {
          console.log(error);
        }
    );
  },
  computed: {
    orderTypes(){
      if(this.category.itemType == "DRINK_ALCOHOL"){
        return ['DINE_IN']; //Alcoholic drinks can only be ordered for dine-in
      } else if(this.category.itemType == "DELIVERY_SERVICE"){
        return ['TAKEAWAY']; //Delivery service is only for takeaway/delivery
      } else {
        return ['DINE_IN', 'TAKEAWAY'];
      }
    },
    activateSaveButton(){
      if(this.category.name.length > 0 && this.category.itemType.length > 0){
        return true;
      } else {
        return false;
      }
    },
    offerDeliveryService(){
      //True if any location offers delivery (offerDeliveryService is now per-location).
      return this.locations.some(location => location.offerDeliveryService);
    }
  },
  watch: {
    /**
     * Picking a type re-decides which order types are POSSIBLE — it does not re-decide which ones the
     * user wants. See requiredOrderTypesFor.
     */
    'category.itemType'(newValue) {
      const required = this.requiredOrderTypesFor(newValue);
      if(required){
        this.category.availableForOrderTypes = required;
        this.orderTypesForcedByType = true;
        return;
      }
      //Unconstrained: both order types are only a DEFAULT for a fresh form, so it must not overwrite a
      //deliberate choice. Picking "Tilgjengelig for" BEFORE "Hva skal kategorien inneholde" used to
      //reset the ticks — choose dine-in only, then choose Matrett, and takeaway came back on. Apply the
      //default only when there is nothing worth keeping: an empty selection, or one a previous
      //restriction imposed rather than the user picking it (so switching away from alcohol does not
      //silently leave the category dine-in only).
      if(this.orderTypesForcedByType || this.category.availableForOrderTypes.length === 0){
        this.category.availableForOrderTypes = ['DINE_IN', 'TAKEAWAY'];
      }
      this.orderTypesForcedByType = false;
    }
  },
  methods: {
    /**
     * The order types a category of this type is RESTRICTED to, or null when the type imposes no
     * restriction. Only a real restriction may overrule what the user ticked.
     */
    requiredOrderTypesFor(itemType){
      if(itemType === "DRINK_ALCOHOL"){
        return ['DINE_IN'];        //alcohol cannot be sold as takeaway
      }
      if(itemType === "DELIVERY_SERVICE"){
        return ['TAKEAWAY'];       //a delivery fee is never a dine-in line
      }
      return null;                 //anything else can be sold as either — the user decides
    },
    getOrderTypeName(orderType){
      if(orderType === 'DINE_IN'){
        return 'Spise Her';
      } else if(orderType === 'TAKEAWAY'){
        return 'Takeaway';
      }
    },
    selectFile(){
      let file = this.$refs.file.files[0];
      ImageCompressor.compressImageToWebp(file).then((compressed) => {
        this.imageFile = compressed;
        console.log("imageFile: " + this.imageFile.name);
      }).catch((error) => {
        console.log("Image compression failed, using original: " + error.message);
        this.imageFile = file;
      });
    },
    hasMultiLocations(){
      return LocationUtil.hasMultiLocations();
    },
    showAvailableForChannels(){
      if(MerchantUtil.useFunctionality() === 'POS' || MerchantUtil.useFunctionality() === 'KIOSK_TAKEAWAY' || MerchantUtil.useFunctionality() === 'ALL' || MerchantUtil.websiteShowDineInMenu()){
        return true;
      }else {
        return false;
      }
    },
    showAvailableForOrderTypes(){
      if(MerchantUtil.useFunctionality() === 'POS' || MerchantUtil.useFunctionality() === 'KIOSK_TAKEAWAY' || MerchantUtil.useFunctionality() === 'ALL' || MerchantUtil.websiteShowDineInMenu()){
        return true;
      }else {
        return false;
      }
    },
    showAvailableOnDays(){
      return MerchantUtil.showAvailableOnDays();
    },
    setSelectedLocations(event){
      //console.log(JSON.stringify(this.category.availableAtLocationIds));
      let locationId = event.target.value;
      if(event.target.checked){
        this.category.availableAtLocationIds.push(locationId);
      } else {
        for (let i=0; i < this.category.availableAtLocationIds.length; i++){
          if (this.category.availableAtLocationIds[i] === locationId) {
            this.category.availableAtLocationIds.splice(i,1);
            break;
          }
        }
      }
      //console.log(JSON.stringify(this.category.availableAtLocationIds));
    },
    setSelectedChannels(event){
      //console.log(JSON.stringify(this.category.validForChannels));
      let channelId = event.target.value;
      if(event.target.checked){
        this.category.availableForChannelIds.push(channelId);
      } else {
        for (let i=0; i < this.category.availableForChannelIds.length; i++){
          if (this.category.availableForChannelIds[i] == channelId) {
            this.category.availableForChannelIds.splice(i,1);
            break;
          }
        }
      }
      //console.log(JSON.stringify(this.category.validForChannels));
    },
    setSelectedOrderTypes(event){
      //Whatever is on screen from here on was chosen by a person, not imposed by the type.
      this.orderTypesForcedByType = false;
      //console.log(JSON.stringify(this.category.availableForOrderTypes));
      let orderType = event.target.value;
      if(event.target.checked){
        this.category.availableForOrderTypes.push(orderType);
      } else {
        for (let i=0; i < this.category.availableForOrderTypes.length; i++){
          if (this.category.availableForOrderTypes[i] === orderType) {
            this.category.availableForOrderTypes.splice(i,1);
            break;
          }
        }
      }
      //console.log(JSON.stringify(this.category.availableForOrderTypes));
    },
    getDayName(day){
      if(day === 'MONDAY'){
        return 'Mandag';
      } else if(day === 'TUESDAY'){
        return 'Tirsdag';
      } else if(day === 'WEDNESDAY'){
        return 'Onsdag';
      } else if(day === 'THURSDAY'){
        return 'Torsdag';
      } else if(day === 'FRIDAY'){
        return 'Fredag';
      } else if(day === 'SATURDAY'){
        return 'Lørdag';
      } else if(day === 'SUNDAY'){
        return 'Søndag';
      } else if(day === 'HOLIDAY'){
        return 'Hellig dag';
      }
      return 'DAY_NOT_DEFINED';
    },
    setSelectedDays(event){
      //console.log(JSON.stringify(this.category.availableOnDays));
      let day = event.target.value;
      if(event.target.checked){
        this.category.availableOnDays.push(day);
      } else {
        for (let i=0; i < this.category.availableOnDays.length; i++){
          if (this.category.availableOnDays[i] === day) {
            this.category.availableOnDays.splice(i,1);
            break;
          }
        }
      }
      //console.log(JSON.stringify(this.category.availableOnDays));
    },
    saveCategory(){
      this.loading = true;

      this.category.merchant = MerchantUtil.getMerchant();
      if(this.imageFile){
        MediaFileService.uploadImageFile(this.imageFile).then(
            (response) => {
              let imageUrl = response.data;
              if(imageUrl){
                //console.log("imageUrl: " + imageUrl);
                this.category.imageUrl = imageUrl;
                this.createCategory(this.category);
              } else {
                console.log("Uploading image failed");
              }
              this.loading = false;
            },
            (error) => {
              console.log(error);
            }
        );
      } else {
        this.createCategory(this.category);
      }
    },
    createCategory(category){
      console.log('category: ' + JSON.stringify(category));
      ProductService.createCategory(category).then(
          (response) => {
            let documentId = response.data;
            if(documentId){
              if(this.panelMode){ this.$emit('saved'); } else { this.$router.push({ path: 'products'}); }
            } else {
              console.log("Creating category failed");
            }
            this.loading = false;
          },
          (error) => {
            console.log(error);
          }
      );
    }
  }
};
</script>

<style scoped>
.panel-sticky-footer {
  position: sticky;
  bottom: 0;
  background-color: var(--bo-surface);
  border-top: 1px solid var(--bo-line);
  padding: 15px 20px;
  z-index: 10;
}
</style>
